import React from "react";
import { useOnMasterStore, MASTER_STORE_LABEL } from "../helpers/storeScope";
import "./master-store-banner.scss";

/**
 * Persistent "Master Store" marker.
 *
 * On Master Store a master admin sees every store's data at once, which makes
 * the screen look like an ordinary store page holding suspiciously much data —
 * and the write entry points are disabled with no visible reason until you hover
 * one (see useStoreWriteGuard). This says so permanently instead.
 *
 * Rendered once by AppShell, which wraps every route, so it covers all pages
 * AND the order/sell/PX flows without per-page wiring.
 *
 * `position: fixed` keeps it in place through any scroll — including pages that
 * scroll an inner container rather than the document, which a `sticky` element
 * inside the page would not survive.
 *
 * Deliberately inert: `pointer-events: none` so a floating overlay can never
 * swallow a click meant for the UI beneath it (on mobile it sits across the
 * topbar's centre, between the hamburger and the notification icons).
 */
const MasterStoreBanner = () => {
  const onMasterStore = useOnMasterStore();

  if (!onMasterStore) return null;

  return (
    <div className="rc-master-store-banner" role="status" aria-live="polite">
      <span className="rc-master-store-banner__pill">
        <span className="rc-master-store-banner__dot" aria-hidden="true" />
        {MASTER_STORE_LABEL}
        <span className="rc-master-store-banner__hint">All Stores</span>
      </span>
    </div>
  );
};

export default MasterStoreBanner;
